import aatroxNew from "./splasharts/Aatrox_New.png";
import aatroxOld from "./splasharts/Aatrox_Old.png";
import ahriNew from "./splasharts/Ahri_New.png";
import ahriOld from "./splasharts/Ahri_Old.png";
import akaliNew from "./splasharts/Akali_New.png";
import akaliOld from "./splasharts/Akali_Old.png";
import alistarNew from "./splasharts/Alistar_New.png";
import alistarOld from "./splasharts/Alistar_Old.png";
import aniviaNew from "./splasharts/Anivia_New.png";
import aniviaOld from "./splasharts/Anivia_Old.png";
import asheNew from "./splasharts/Ashe_New.png";
import asheOld from "./splasharts/Ashe_Old.png";
import blitzcrankNew from "./splasharts/Blitzcrank_New.png";
import blitzcrankOld from "./splasharts/Blitzcrank_Old.png";
import caitlynNew from "./splasharts/Caitlyn_New.png";
import caitlynOld from "./splasharts/Caitlyn_Old.png";
import cassiopeiaNew from "./splasharts/Cassiopeia_New.png";
import cassiopeiaOld from "./splasharts/Cassiopeia_Old.png";
import ezrealNew from "./splasharts/Ezreal_New.png";
import ezrealOld from "./splasharts/Ezreal_Old.png";
import fiddlesticksNew from "./splasharts/Fiddlesticks_New.png";
import fiddlesticksOld from "./splasharts/Fiddlesticks_Old.png";
import fioraNew from "./splasharts/Fiora_New.png";
import fioraOld from "./splasharts/Fiora_Old.png";
import gangplankNew from "./splasharts/Gangplank_New.png";
import gangplankOld from "./splasharts/Gangplank_Old.png";
import galioNew from "./splasharts/Galio_New.png";
import galioOld from "./splasharts/Galio_Old.png";
import heimerdingerNew from "./splasharts/Heimerdinger_New.png";
import heimerdingerOld from "./splasharts/Heimerdinger_Old.png";
import ireliaNew from "./splasharts/Irelia_New.png";
import ireliaOld from "./splasharts/Irelia_Old.png";
import katarinaNew from "./splasharts/Katarina_New.png";
import katarinaOld from "./splasharts/Katarina_Old.png";
import luxNew from "./splasharts/Lux_New.png";
import luxOld from "./splasharts/Lux_Old.png";
import malphiteNew from "./splasharts/Malphite_New.png";
import malphiteOld from "./splasharts/Malphite_Old.png";
import missFortuneNew from "./splasharts/MissFortune_New.png";
import missFortuneOld from "./splasharts/MissFortune_Old.png";
import nasusNew from "./splasharts/Nasus_New.png";
import nasusOld from "./splasharts/Nasus_Old.png";
import olafNew from "./splasharts/Olaf_New.png";
import olafOld from "./splasharts/Olaf_Old.png";
import poppyNew from "./splasharts/Poppy_New.png";
import poppyOld from "./splasharts/Poppy_Old.png";
import seraphineNew from "./splasharts/Seraphine_New.png";
import shyvanaNew from "./splasharts/Shyvana_New.png";
import shyvanaOld from "./splasharts/Shyvana_Old.png";
import sionNew from "./splasharts/Sion_New.png";
import sionOld from "./splasharts/Sion_Old.png";
import sivirNew from "./splasharts/Sivir_New.png";
import sivirOld from "./splasharts/Sivir_Old.png";
import sonaNew from "./splasharts/Sona_New.png";
import sonaOld from "./splasharts/Sona_Old.png";
import teemoNew from "./splasharts/Teemo_New.png";
import teemoOld from "./splasharts/Teemo_Old.png";
import trundleNew from "./splasharts/Trundle_New.png";
import trundleOld from "./splasharts/Trundle_Old.png";
import varusNew from "./splasharts/Varus_New.png";
import varusOld from "./splasharts/Varus_Old.png";
import vayneNew from "./splasharts/Vayne_New.png";
import vayneOld from "./splasharts/Vayne_Old.png";
import veigarNew from "./splasharts/Veigar_New.png";
import veigarOld from "./splasharts/Veigar_Old.png";
import viktorNew from "./splasharts/Viktor_New.png";
import viktorOld from "./splasharts/Viktor_Old.png";
import warwickNew from "./splasharts/Warwick_New.png";
import warwickOld from "./splasharts/Warwick_Old.png";
import xerathNew from "./splasharts/Xerath_New.png";
import xerathOld from "./splasharts/Xerath_Old.png";

import KillerskinsLogo from "./splasharts/Killerskins_Logo.png";

export const SplashArtAmount = 36;

const getSplashArt = file => {
  const splasharts = {
    old: [
      aatroxOld,
      ahriOld,
      akaliOld,
      alistarOld,
      aniviaOld,
      asheOld,
      blitzcrankOld,
      caitlynOld,
      cassiopeiaOld,
      ezrealOld,
      fiddlesticksOld,
      fioraOld,
      galioOld,
      gangplankOld,
      heimerdingerOld,
      ireliaOld,
      katarinaOld,
      luxOld,
      malphiteOld,
      missFortuneOld,
      nasusOld,
      olafOld,
      poppyOld,
      shyvanaOld,
      sionOld,
      sivirOld,
      sonaNew,
      sonaOld,
      teemoOld,
      trundleOld,
      varusOld,
      vayneOld,
      veigarOld,
      viktorOld,
      warwickOld,
      xerathOld
    ],
    new: [
      aatroxNew,
      ahriNew,
      akaliNew,
      alistarNew,
      aniviaNew,
      asheNew,
      blitzcrankNew,
      caitlynNew,
      cassiopeiaNew,
      ezrealNew,
      fiddlesticksNew,
      fioraNew,
      galioNew,
      gangplankNew,
      heimerdingerNew,
      ireliaNew,
      katarinaNew,
      luxNew,
      malphiteNew,
      missFortuneNew,
      nasusNew,
      olafNew,
      poppyNew,
      shyvanaNew,
      sionNew,
      sivirNew,
      seraphineNew,
      sonaNew,
      teemoNew,
      trundleNew,
      varusNew,
      vayneNew,
      veigarNew,
      viktorNew,
      warwickNew,
      xerathNew
    ]
  };

  if (file === undefined) {
    return KillerskinsLogo;
  }

  const index = file.besen;
  const type = file.type || file.fileType;
  const splashArt = { old: splasharts.old[index], new: splasharts.new[index] };

  if (type === "TROYBIN" || type === "CONV_TROYBIN") {
    return splashArt.old;
  }

  return splashArt.new;
};

export default getSplashArt;
